import React from "react";
import { List, Avatar, Typography } from "antd";
import "./index.css";
import { currencyFormat } from "../../../../../../../utils/media";

const { Text } = Typography;

interface ApplicationClientCardProps {
  name?: string;
  index?: number;
  createdBookings?: number;
  achievement: number;
  position?: number;
  createdBookingValues?: number;
  completedBookings?: number;
  completedBookingValues?: number;
}

const ApplicationClientCard: React.FC<ApplicationClientCardProps> = React.memo(
  ({
    name,
    index,
    createdBookings,
    createdBookingValues,
    completedBookings,
    completedBookingValues,
    achievement,
    position,
  }) => {
    return (
      <List.Item
        className="application-table"
        style={{
          backgroundColor: position === 0 ? "#F8F8F8" : "#ffffff",
          borderRadius: 8,
          border: position === 0 ? "none" : "1px solid #E9E9E9",
          boxShadow: "none",
          padding: "12px",
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "12px",
          marginBottom: "12px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", flex: "2 1 250px" }}>
          <Avatar style={{ backgroundColor: "#1f5782" }} size={40}>
            {name ? name?.slice(0, 2)?.toUpperCase() : "-"}
          </Avatar>
          <Text style={{ color: "#303030", fontWeight: 600, marginLeft: 10 }}>{name}</Text>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: "1 1 120px",
            gap: "8px",
          }}
        >
          <Text style={{ fontWeight: 900, color: "#ECECEC", fontSize: 24 }}>{position}</Text>
        </div>

        <div style={{ flex: "1 1 100px", textAlign: "center" }}>
          <Text style={{ color: "#333", fontWeight: 500 }}>
            {createdBookings}
            <br />
            {currencyFormat(createdBookingValues)}
          </Text>
        </div>

        <div style={{ flex: "1 1 120px", textAlign: "center" }}>
          {completedBookings}
          <br />
          <Text style={{ color: "#333", fontWeight: 500 }}>{currencyFormat(completedBookingValues)}</Text>
        </div>

        <div style={{ flex: "1 1 100px", textAlign: "center" }}>
          <Text style={{ color: "#333", fontWeight: 500 }}>{achievement?.toFixed(2)}%</Text>
        </div>
      </List.Item>
    );
  }
);

export default React.memo(ApplicationClientCard);
